import { z } from "zod";

/** 当前登录用户资料。 */
export type AuthUser = {
  id: number;
  username: string;
  displayName: string;
  realname: string | null;
  nickname: string | null;
  email: string | null;
  phone: string | null;
  roles: string[];
  scopes: string[];
  permissions?: string[];
  isSuperuser: boolean;
  isStaff: boolean;
  wxOpenid: string | null;
  wxUnionid: string | null;
};

/** 登录会话。 */
export type AuthSession = {
  accessToken: string;
  tokenType: "bearer";
  expiresIn: number;
  user: AuthUser;
};

/** 旧系统单点号登录请求。 */
export type AuthLegacySingleLoginMutation = {
  singleLoginNo: string;
};

/** 旧系统跳转地址请求。 */
export type AuthLegacyJumpUrlMutation = {
  targetUrl: string;
};

/** 旧系统跳转地址结果。 */
export type AuthLegacyJumpUrlPayload = {
  jumpUrl: string;
};

/** 管理员重置密码请求。 */
export type AuthPasswordResetMutation = {
  password: string;
};

/** 管理员重置密码结果。 */
export type AuthPasswordResetPayload = {
  userId: number;
};

/** 登录表单校验规则。 */
export const loginSchema = z.object({
  login: z.string().trim().min(1, "请输入账号、手机号或邮箱"),
  password: z.string().min(6, "密码至少 6 位"),
});

/** 注册表单校验规则。 */
export const registerSchema = z.object({
  username: z.string().trim().min(2, "用户名至少 2 位"),
  realname: z.string().trim().min(1, "请输入姓名"),
  phone: z.string().trim().min(6, "请输入手机号"),
  email: z.string().trim().email("邮箱格式不正确").optional().or(z.literal("")),
  password: z.string().min(6, "密码至少 6 位"),
});

/** 登录表单值类型。 */
export type LoginFormValues = z.infer<typeof loginSchema>;

/** 注册表单值类型。 */
export type RegisterFormValues = z.infer<typeof registerSchema>;
